<template>
  <div class="mains">
    <div class="tiyouimg">
      <img src="../assets/img/xmsb/xmsb8.png" alt="">
    </div>
    <div style="display: flex;margin: 0 15%;width: 70%;height: auto;margin-top: 40px">
      <div style="display: flex;align-items: center;flex-direction: column">
        <div style="font-size: 52px;
          font-family: zcoolqingkehuangyouti;
          font-weight: bold;
          color: #0fb1af;
          line-height: 60px;">01</div>
        <div style="font-size: 18px;

          font-weight: 400;
          color: #6C6D6D;
          line-height: 28px;">
          <img src="../assets/img/xmsb/xmsb3.png" alt="">
        </div>
        <div style="font-size: 28px;

          font-weight: bold;
          color: #242424;
          line-height: 46px;">
          新专业申报
        </div>
        <div class="div_font" style="width: 80%;margin: 23px 10%">
          学校新专业申报材料编写，搜集新专业相关行业内最新咨询、企业人才需求、国家政策文件，推动新专业申报流程。
        </div>
      </div>
      <div >
        <div style="width: 2px;height: 100%">
          <img src="../assets/img/xmsb/xmsb2.png" alt="">
        </div>
      </div>

      <div style="display: flex;align-items: center;flex-direction: column">
        <div style="font-size: 52px;
          font-family: zcoolqingkehuangyouti;
          font-weight: bold;
          color:#0fb1af;
          line-height: 60px;">02</div>
        <div style="font-size: 18px;

          font-weight: 400;
          color: #6C6D6D;
          line-height: 28px;">
          <img src="../assets/img/xmsb/xmsb4.png" alt="">
        </div>
        <div style="font-size: 28px;

          font-weight: bold;
          color: #242424;
          line-height: 46px;">
          五年一贯制专业申报
        </div>
        <div class="div_font" style="width: 80%;margin: 23px 10%">
          学校五年一贯制专业申报材料编写，调研该专业相关行业发展趋势、提供该专业设置可行性报告，以企业角度辅助设计人才培养方案。
        </div>
      </div>

      <div>
        <div style="width: 2px;height: 100%">
          <img src="../assets/img/xmsb/xmsb2.png" alt="">
        </div>
      </div>

      <div style="display: flex;align-items: center;flex-direction: column">
        <div style="font-size: 52px;
          font-family: zcoolqingkehuangyouti;
          font-weight: bold;
          color: #0fb1af;
          line-height: 60px;">03</div>
        <div style="font-size: 18px;

          font-weight: 400;
          color: #6C6D6D;
          line-height: 28px;">
          <img src="../assets/img/xmsb/xmsb3.png" alt="">
        </div>
        <div style="font-size: 28px;

          font-weight: bold;
          color: #242424;
          line-height: 46px;">
          贯通专业申报
        </div>
        <div class="div_font" style="width: 80%;margin: 23px 10%">
          学校贯通专业申报材料编写，设计调研问卷并进行人才需求市场调研，与校方沟通制定试点方案，以企业角度提供人才培养建议。
        </div>
      </div>
    </div>

    <div style="width: 70%;margin: 50px 15%;height:100%;display: flex;justify-content: center;align-items: center;flex-direction: column">
      <div style="font-size: 32px;

        font-weight: bold;
        color: #1F2D5D;
        line-height: 18px;">
        案例展示/CASE SHOW
      </div>
      <div style="width: 100%;height: auto;margin-top: 25px">
        <div style="width: 100%;height: auto;padding: 0 30px;position: relative">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div
                  class="swiper-slide lunbopic"
                  :list="list"
                  v-for="item in list"
                  :key="item.id"
              >
                <img :src="item.src" alt="" />
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <!--          <div class="swiper-pagination"></div>-->
            <!-- 如果需要滚动条 -->
            <!--    <div class="swiper-scrollbar"></div>-->
          </div>

          <!-- 如果需要导航按钮 -->
          <!--          <div class="swiper-button-prev"></div>-->
          <!--          <div class="swiper-button-next"></div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import Swiper from 'swiper'
export default {
  name: "Xmsb",
  components: {
    Swiper
  },
  data(){
    return{
      list:[
      ],
    }
  },
  created() {
    this.initpic()
  },
  mounted() {
    /* eslint-disable no-new */
    setTimeout(()=>{
      this.swiper()//防止第一张图闪过
    },500)
  },
  methods: {
    swiper(){
      new Swiper('.swiper-container', {
        slidesPerView: 5,
        spaceBetween : 20,
        loop: true,
// 如果需要分页器
        pagination: '.swiper-pagination',
// 如果需要前进后退按钮
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        // 如果需要滚动条
        // scrollbar: '.swiper-scrollbar',
        // 如果需要自动切换海报
        speed:4000,
        autoplay: {
          delay: 0,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        autoplayDisableOnInteraction: false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
      })
    },
//初始化图片
    initpic(){
      for (let i = 1; i < 13; i++) {
        this.list.push({id:i,src:require("../assets/img/xmsb2/xmsb"+i+".png")})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
img{
  width: 100%;
  height: auto;
  max-height: 100%;
  max-width: 100%;
}
.mains {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: white;
  flex-direction: column;
  display: flex;

  .tiyouimg {
    width: 100%;
  }
}
.lunbopic{
  display: flex;
  align-items: center;
  //height: 342px;
  img{
    width: 100%;
    height: auto;
    max-width: 100%;
    max-height: 100%;
  }
}
.swiper-container{
  position: relative;
  width: 100%;
  height: 100%;
}

/*去掉默认样式*/
.swiper-button-prev:after{
  display: none;
}
.swiper-button-next:after{
  display: none;
}
/*自定义样式*/
.swiper-button-prev{
  position: absolute;
  background-color: #fff;
  width: 51px;
  height: 51px;
  border-radius: 50%;
  font-size: 16px;
  background-size: 30% 30%;/*按比例缩放*/
  top: 50%;
  left: 0.8%;
  box-shadow: 0 0 10px #888888;
}

.swiper-button-next{
  position: absolute;
  background-color: #fff;
  width: 51px;
  height: 51px;
  border-radius: 50%;
  background-size: 30% 30%;/*按比例缩放*/
  top: 50%;
  right: 0.8%;
  box-shadow: 0 0 10px #888888;
}
.swiper-container .swiper-wrapper{
  -webkit-transition-timing-function: linear; /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
}
.div_font{
  font-size: 14px;
}
</style>
